import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Afterschool2 from "./Afterschool2";
import Testimonials from "./Testimonials";
import reviews from "./data";


import afterschool1 from "../../Assets/afterschool1.jpg";
import afterschool2 from "../../Assets/afterschool2.jpg";
import afterschool3 from "../../Assets/afterschool3.jpg";
import afterschool4 from "../../Assets/afterschool4.jpg";
import afterschool5 from "../../Assets/afterschool.jpeg";




// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";
import { useTranslation } from "react-i18next";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  { src: afterschool1, alt: "afterschool" },
  { src: afterschool2, alt: "afterschool" },
  { src: afterschool3, alt: "afterschool" },
  { src: afterschool4, alt: "afterschool" }, 
  { src: afterschool5, alt: "afterschool" }, 
 



  // Add more images as needed

  ];


function Afterschool() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const navigate = useNavigate(); // Initialize navigate
  
  const handleClick = () => {
    navigate("/registration#afterschool-section"); // This will navigate to the "/another-page" route
  };

  


  // Settings for the Slick slider
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 700, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3600, // Time between slides in ms
    pauseOnHover: true,
    pauseOnFocus: true,
    lazyLoad: "progressive",
    beforeChange: (_current, next) => setActiveSlide(next),
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <SlickLazyImage
                    src={image.src}
                    alt={t("programs.afterschool.sliderAlt")}
                    className="img-fluid program-page-slide-img"
                    index={index}
                    activeIndex={activeSlide}
                    total={sliderImages.length}
                    buffer={2}
                    eager
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>

   
       <Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  {t("common.registerNow")}
</Button>

     
      
          <Afterschool2 />

                                        
                    <div className="testimonials">
          <Testimonials reviews={reviews}/>              
          </div>
             

          
           
    </section>
  );
}

export default Afterschool;


